import axios from 'axios';
import { notificationHandler } from '../services/NotificationHandler';

const httpClient = axios.create({
  withCredentials: true,
  headers: {
    'Access-Control-Allow-Origin': '*',
    'Content-type': 'application/json'
  },
})

export const onFulfilled = res => res?.data?.result;

export const onRejected = error => {
  notificationHandler.handleError(error?.response?.data)
  throw error
}

httpClient.interceptors.response.use(onFulfilled, onRejected);

export {
  httpClient,
}
